var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"gl-ml-5"},[(_vm.isLoading)?_c('gl-loading-icon',{attrs:{"size":"sm","label":"Loading pipeline status"}}):_c('a',{attrs:{"href":_vm.ciStatus.details_path}},[_c('ci-icon',{attrs:{"status":_vm.ciStatus,"title":_vm.statusTitle,"aria-label":_vm.statusTitle}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }